<template>
  <li class="bg-beige flex flex-col md:flex-row locations-list-item">
    <div class="lg:w-1/2 px-tiny pt-semi pb-13 md:py-22 md:px-xl order-2 md:order-1">
      <span class="font-gt-america-extended uppercase text-smallest text-light-gray">
        {{ location.type }}
      </span>
      <h3 class="font-gt-america font-bold text-bigger md:text-display-12 mt-1 md:mt-2 leading-6 md:leading-12">
        {{ location.name }}
      </h3>
      <span class="font-gt-america font-light flex items-start text-base text-light-gray my-tiny md:mt-standart md:mb-tiny">
        <MajorityUiMajorityIcon icon="map-pin" class="mr-2 dark-jungle-green" />
        {{ location.address }}
      </span>
      <p
        class="text-light-gray mt-0 mb-semi location-opening-hours"
        :class="{ 'location-opening-hours-spanish': isSpanish }"
        v-html="$messages('locations.locations_list_item.openingHours')"
      />
      <a class="order-2 btn btn-black lg:order-1 lg:mr-6" :href="location.directionsLink" :aria-label="location.name">
        {{ $messages('locations.locations_list_item.cta') }}
      </a>
    </div>
    <SharedImageCarousel
      class="lg:w-1/2 order-1"
      :images="location.images"
      :is-first="first"
    />
  </li>
</template>
<script>

export default {
  props: {
    location: {
      type: Object,
      required: true
    },
    first: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isSpanish () {
      return this.$i18n.locale === 'es'
    }
  }
}
</script>

<style lang="postcss" scoped>
  .locations-list-item {
    @screen md {
      max-height: 440px;
    }
  }
  .dark-jungle-green {
    color: #222120;
  }

  .location-opening-hours {
    width: 17ch;
  }

  .location-opening-hours-spanish {
    width: 25ch;
  }
</style>
